export const SHORTCUT_REORDER_MIME = 'application/x-erp-shortcut-reorder';

export const SHORTCUT_ADD_MIME = 'application/x-erp-shortcut-add';

export interface ShortcutDragPayload {
  path: string;
  label: string;
  moduleKey?: string;
  state?: any;
}

/**
 * Writes a shortcut-add drag payload onto a DataTransfer at dragstart.
 * The dropdown that sources the drag can unmount mid-drag (closes on
 * mouse-leave), so everything the drop handler needs must live in
 * dataTransfer — never in React state or refs.
 */
export const setShortcutDragPayload = (
  dataTransfer: DataTransfer,
  payload: ShortcutDragPayload
): void => {
  dataTransfer.setData(SHORTCUT_ADD_MIME, JSON.stringify(payload));
  dataTransfer.effectAllowed = 'copy';
};

/**
 * Reads back a shortcut-add drag payload from a DataTransfer on drop.
 * Never throws — returns null on missing/malformed data so a drop
 * handler can safely ignore an unrecognized drag.
 */
export const getShortcutDragPayload = (
  dataTransfer: DataTransfer
): ShortcutDragPayload | null => {
  try {
    const raw = dataTransfer.getData(SHORTCUT_ADD_MIME);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.path !== 'string' || typeof parsed.label !== 'string') {
      return null;
    }
    return parsed as ShortcutDragPayload;
  } catch {
    return null;
  }
};
